import styled from "styled-components";

import { BaseCell, type BaseCellProps } from "@similarweb/pro-logic-components";

export const StyledCountryFlagContainer = styled.div<{ width?: string; height?: string }>`
    display: flex;
    flex-shrink: 0;
`;

export const StyledRegionIconContainer = styled.div`
    display: flex;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
`;

export const StyledSignleLocationBaseCell = styled(BaseCell)<BaseCellProps>`
    display: flex;
    column-gap: 7px;

    user-select: none;
`;
